// Application Configuration
export const appConfig = {
  // App Info
  name: process.env.REACT_APP_NAME || 'AI Chat',
  description: process.env.REACT_APP_DESCRIPTION || 'ChatGPT/Gemini-like web application',
  
  // Auth0 Configuration
  auth0: {
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
    redirectUri: process.env.REACT_APP_AUTH0_REDIRECT_URI || window.location.origin,
  },
  
  // API Configuration
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || '/api',
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT) || 30000,
  },
  
  // Feature Flags
  features: {
    fileUpload: process.env.REACT_APP_ENABLE_FILE_UPLOAD === 'true',
    voiceInput: process.env.REACT_APP_ENABLE_VOICE_INPUT === 'true',
    feedback: process.env.REACT_APP_ENABLE_FEEDBACK !== 'false', // default true
  },
  
  // UI Configuration
  ui: {
    maxMessageLength: parseInt(process.env.REACT_APP_MAX_MESSAGE_LENGTH) || 1000,
    messagesPerPage: parseInt(process.env.REACT_APP_MESSAGES_PER_PAGE) || 50,
    autoSaveInterval: parseInt(process.env.REACT_APP_AUTO_SAVE_INTERVAL) || 30000,
  },
  
  // Theme Configuration
  theme: {
    colors: {
      primary: '#007bff',
      secondary: '#6c757d',
      success: '#28a745',
      danger: '#dc3545',
      warning: '#ffc107',
      info: '#17a2b8',
      light: '#f8f9fa',
      dark: '#343a40',
    },
    gradients: {
      primary: 'from-blue-600 to-purple-600',
      user: 'from-green-500 to-blue-500',
      ai: 'from-blue-600 to-purple-600',
    }
  }
};

// Validation function to check if all required env vars are present
export const validateConfig = () => {
  const requiredVars = [
    'REACT_APP_AUTH0_DOMAIN',
    'REACT_APP_AUTH0_CLIENT_ID'
  ];
  
  const missingVars = requiredVars.filter(varName => !process.env[varName]);
  
  if (missingVars.length > 0) {
    console.error('Missing required environment variables:', missingVars);
    throw new Error(`Missing required environment variables: ${missingVars.join(', ')}`);
  }
  
  return true;
};

export default appConfig; 